import { Permission } from '../types';

/**
 * Mapeamento de rotas para permissões necessárias
 * Se uma rota não estiver aqui, ela não requer permissão específica (apenas autenticação)
 */
export const ROUTE_PERMISSIONS: Record<string, Permission> = {
  // Dashboard
  '/dashboard': Permission.ViewDashboard,
  
  // Engenharia
  '/engineering/overview': Permission.ViewEngineeringMetrics,
  '/engineering/contributors': Permission.ViewContributors,
  '/engineering/repositories': Permission.ViewRepositories,
  
  // Planejamento
  '/engineering/goal-plans': Permission.ViewPlanning,
  '/engineering/reports': Permission.ViewPlanning,
  '/planning/platforms': Permission.ViewPlanning,
  '/planning/budget': Permission.ViewPlanning,
  
  // Confiabilidade
  '/reliability/incidents': Permission.ViewIncidents,
  '/reliability/metrics': Permission.ViewReliabilityMetrics,
  
  // Organização
  '/org/members': Permission.ViewMembers,
  
  // Configurações
  '/settings/integrations': Permission.ManageIntegrations,
  '/settings/repositories': Permission.ManageRepositories,
  '/settings/extraction': Permission.ManageExtractionConfig,
  '/settings/manual-sync': Permission.ManageManualSync,
  '/settings/permissions': Permission.ManagePermissions,
};

/**
 * Verifica se uma rota requer permissão específica
 */
export function getRoutePermission(path: string): Permission | null {
  // Verificar rota exata
  if (ROUTE_PERMISSIONS[path]) {
    return ROUTE_PERMISSIONS[path];
  }
  
  // Verificar se a rota começa com algum caminho mapeado
  for (const [route, permission] of Object.entries(ROUTE_PERMISSIONS)) {
    if (path.startsWith(route)) {
      return permission;
    }
  }
  
  return null;
}

/**
 * Verifica se uma rota deve ser exibida no menu baseado em permissões
 */
export function shouldShowRoute(path: string, hasPermission: (permission: Permission) => boolean): boolean {
  const requiredPermission = getRoutePermission(path);
  
  // Se não requer permissão específica, sempre mostrar (apenas autenticação necessária)
  if (!requiredPermission) {
    return true;
  }
  
  // Verificar se o usuário tem a permissão necessária
  return hasPermission(requiredPermission);
}
